import { memo as Memo, useState, useRef } from 'react';
import { gsap } from 'gsap';

//* HOC's
import withLanguageContext from 'context/consumerHOC/LanguageConsumer';

//* Components
import Text from 'components/common/Text';
import CustomLink from 'components/common/CustomLink';
import Image from 'components/common/Image';

//* Style
import ProjectInfoStyle from './style';

const ProjectInfo = Memo(({ className, name, service, industry, client, year, websiteLink, awards, overview, challenge, solution, translate }) => {
	//! State
	const [showMore, setShowMore] = useState(false);

	//! Refs
	const textsRef = useRef();

	const handleClickAnim = (item) => {
		setShowMore(!showMore);
		if (showMore) {
			gsap.to(item, { opacity: 0, duration: 0.7 }).then(() => {
				gsap.to(item, { height: 0, duration: 0.7 });
			});
		} else {
			gsap.to(item, { height: 'auto', duration: 0.7 }).then(() => {
				gsap.to(item, { opacity: 1, duration: 0.7 });
			});
		}
	};

	return (
		<ProjectInfoStyle className={`${className || ''}`}>
			<div className={`nameServiceWrap`}>
				<Text
					className={`h2 gilroyMedium blackRussian uppercase name`}
					text={name}
				/>
				<Text
					className={`serviceWrap gilroyMedium uppercase gray44 h5`}
					text={service}
				/>
			</div>
			<div className={`informationWrap`}>
				<div className={`leftPart`}>
					<div className={`leftColWrap`}>
						<div className={`leftCol`}>
							<div className={`leftTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`industry`}
								/>
							</div>
							<Text
								className={`h6 maisonNeueBook blackRussian`}
								text={industry}
							/>
						</div>
						<div className={`leftCol`}>
							<div className={`leftTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`client`}
								/>
							</div>
							<Text
								className={`h6 maisonNeueBook blackRussian`}
								text={client}
							/>
						</div>
						<div className={`leftCol`}>
							<div className={`leftTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`year`}
								/>
							</div>
							<Text
								className={`h6 maisonNeueBook blackRussian`}
								text={year}
							/>
						</div>
						{websiteLink && (
							<div className={`leftCol`}>
								<div className={`leftTitleWrap`}>
									<Text
										className={`pS gilroyLight gray44 uppercase`}
										text={`website`}
									/>
								</div>
								<CustomLink
									url={websiteLink}
									ariaLabel={websiteLink}
									className={`websiteLink`}
									options={{ target: '_blank', rel: 'noopener noreferrer' }}>
									<Text
										className={`h6 maisonNeueBook blackRussian`}
										text={`visitWebsite`}
									/>
								</CustomLink>
							</div>
						)}
					</div>

					{awards.length > 0 && (
						<>
							<Text
								className={`pS gilroyLight gray44 uppercase awards`}
								text={`awards`}
							/>
							<div className={`awardsWrap`}>
								{awards.map((award, ind) => (
									<div
										className={`awardImageWrap`}
										key={ind}>
										<CustomLink
											url={award.link}
											ariaLabel={award.link}
											options={{ target: '_blank', rel: 'noopener noreferrer' }}>
											<Image
												priority
												objectFit={'contain'}
												src={award.image.url}
												alt={award.image.alt}
											/>
										</CustomLink>
									</div>
								))}
							</div>
						</>
					)}
				</div>
				<div className={`rightPart`}>
					<div className={`rightIntPart`}>
						<div className={`rightCol`}>
							<div className={`rightTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`overview`}
								/>
							</div>
							<div className={`rightDescWrap`}>
								<Text
									className={`p maisonNeueBook blackRussian`}
									text={overview}
								/>
							</div>
						</div>
						<div className={`rightCol`}>
							<div className={`rightTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`challenge`}
								/>
							</div>
							<div className={`rightDescWrap`}>
								<Text
									className={`p maisonNeueBook blackRussian`}
									text={challenge}
								/>
							</div>
						</div>
						<div className={`rightCol`}>
							<div className={`rightTitleWrap`}>
								<Text
									className={`pS gilroyLight gray44 uppercase`}
									text={`solution`}
								/>
							</div>
							<div className={`rightDescWrap`}>
								<Text
									className={`p maisonNeueBook blackRussian additionalStyle`}
									text={solution.show}
								/>

								{solution.more && (
									<div className={`lessMoreAnimWrap`}>
										<div
											className={`lessMoreAnimIntWrap`}
											ref={textsRef}>
											<Text
												className={`p maisonNeueBook blackRussian additionalStyle`}
												text={solution.more}
											/>
										</div>
										<div className={`btnWrap`}>
											<div className={`btnInternalWrap`}>
												<Text
													className={`h4 gilroySemiBold blackRussian uppercase btnLineAnim linkWrap`}
													onClick={() => handleClickAnim(textsRef.current)}>
													{showMore ? translate('clickForLess') : translate('clickForMore')}
												</Text>
											</div>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</ProjectInfoStyle>
	);
});

export default withLanguageContext(ProjectInfo, ['translate']);
